"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesConfig = void 0;
const helpers_1 = require("../../helpers");
exports.stylesConfig = {
    marginLeft: `-${helpers_1.SPACING_S}`,
    marginRight: `-${helpers_1.SPACING_S}`,
    marginBottom: helpers_1.SPACING_L,
    paddingBottomLastTd: helpers_1.SPACING_XS
};
//# sourceMappingURL=constants.js.map